import { createSlice, createSelector } from "@reduxjs/toolkit"

const INITIAL_STATE = {
  matches: {},
}

const matchSlice = createSlice({
  name: "cv",
  initialState: INITIAL_STATE,
  reducers: {
    reset: (state) => {
      state = INITIAL_STATE
    },
    setMatches: (state, action) => {
      state.matches = action.payload
    },
    addOrUpdateMatch: (state, action) => {
      state.matches = {
        ...state.matches,
        [action.payload.vacancy_id]: action.payload,
      }
    },
    updateMatch: (state, action) => {
      state.matches[action.payload.vacancy_id] = {
        ...state.matches[action.payload.vacancy_id],
        ...action.payload,
      }
    },
    removeMatch: (state, action) => {
      delete state.matches[action.payload]
    },
    resetMatchSlice: (state) => {
      Object.keys(INITIAL_STATE).forEach((key) => {
        state[key] = INITIAL_STATE[key]
      })
    },
  },
})

export const {
  reset,
  setMatches,
  addOrUpdateMatch,
  updateMatch,
  removeMatch,
  resetMatchSlice
} = matchSlice.actions

export default matchSlice.reducer

// Selector to get matches slice from state
const selectMatchesState = (state) => state.matches

// Memoized selector factory for selecting a match by jobId
export const selectMatchByJobId = () => createSelector(
  [selectMatchesState, (_, jobId) => jobId],
  (matches, jobId) => matches[jobId]
)
